import { FC, useMemo } from "react";
import { GoalEvent, MatchEvent } from "refsix-js-models";
import { goalEventsSorted, liveScore } from "../replayUtils";

interface ReplayScoreProps {
    matchEvents: MatchEvent[];
    currentTimestamp: number;
}

/**
 * Live score overlay that tallies goals up to the current playback timestamp.
 * Ported from the legacy ReplayScoreDirective.
 */
const ReplayScore: FC<ReplayScoreProps> = ({
    matchEvents,
    currentTimestamp,
}) => {
    const goalEvents = useMemo(
        () => goalEventsSorted(matchEvents) as GoalEvent[],
        [matchEvents]
    );

    const score = useMemo(
        () => liveScore(goalEvents, currentTimestamp),
        [goalEvents, currentTimestamp]
    );

    return (
        <div className="score">
            <span className="home-score">{score.home}</span> -{" "}
            <span className="away-score">{score.away}</span>
        </div>
    );
};

export default ReplayScore;
